import React from 'react';
import { TextButton } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import AiInsightsIcon from '../../assets/images/aiInsightsIcon.svg';
import s from './AiInsightsButton.module.scss';
export const AiInsightsButton = _ref => {
  let {
    onClick
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(TextButton, {
    prefixIcon: /*#__PURE__*/React.createElement(AiInsightsIcon, null),
    skin: "dark",
    size: "small",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: s.aiInsightsText
  }, t('domain_search_suite.results.insight_widget.header')));
};
//# sourceMappingURL=AiInsightsButton.js.map